import { SourceType } from 'module/api/filter/types';

export enum FilterGroupType {
  Task = SourceType.Task,
  Project = SourceType.Project,
  User = SourceType.User,
  Phase = SourceType.Phase,
  Timesheet = SourceType.Timesheet,
  Role = SourceType.Role,
  StarMeta = SourceType.StarMeta,
  ResourceRequest = SourceType.ResourceRequest,
  Invoice = SourceType.Invoice,
  Financial = SourceType.Financial,
  Company = SourceType.Company,
  Formula = SourceType.Formula,
  Allocations = 'allocations',
  Utilisations = 'utilisations',
  Skill = 'skill',
  Meeting = 'meeting',
  Signal = SourceType.Signal,
  Email = SourceType.Email,
}
